var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4191 5.99084L13.4357 0.22711C13.0755 0.0193488 12.6318 0.0193488 12.2713 0.22711C11.9108 0.434871 11.6889 0.82035 11.6889 1.23587V5.96732L1.74715 0.22711C1.38628 0.0193488 0.942887 0.0193488 0.582382 0.22711C0.221877 0.434871 0 0.82035 0 1.23587V12.7637C0 13.1792 0.221877 13.564 0.582382 13.7717C0.762634 13.8756 0.963518 13.9281 1.1644 13.9281C1.36529 13.9281 1.56653 13.8756 1.74678 13.7717L11.6882 8.03226V12.7637C11.6882 13.1792 11.9097 13.564 12.2702 13.7717C12.4504 13.8756 12.6521 13.9281 12.8526 13.9281C13.0531 13.9281 13.2547 13.8756 13.4342 13.7717L23.4176 8.00801C23.7781 7.80025 24 7.41549 24 6.99925C24.0014 6.58372 23.7796 6.19861 23.4191 5.99084Z",
    fill: "#4B7FEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.aeeeee4e519dfbf2db119de4df5b908b.svg";
export { ForwardRef as ReactComponent };